// const PREFIX = 'http://localhost:5000';
const PREFIX = 'https://api.belong.education';
// const PREFIX = 'https://development-belong-api.herokuapp.com';

export const UPLOAD_OR_DOWNLOAD_URL = `${PREFIX}/api/upload`;
export const API_URL = `${PREFIX}/api`;
export const USER_BATCH_URL = `${PREFIX}/api/user-batch-details`;
